/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/sections/judgeme-carousel-section.js":
/*!**********************************************************!*\
  !*** ./zrc/scripts/sections/judgeme-carousel-section.js ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/js/swiper.esm.bundle.js\");\n// eslint-disable\n // import { Navigation } from \"swiper\";\n\n(function () {\n  // Save a reference to the native open() and send() methods\n  var origOpen = XMLHttpRequest.prototype.open;\n  var origSend = XMLHttpRequest.prototype.send;\n  var request_count = 0;\n\n  XMLHttpRequest.prototype.open = function (method, url, ...rest) {\n    this._judgeme_url = url; // store the request URL for later\n\n    return origOpen.apply(this, [method, url, ...rest]);\n  };\n\n  XMLHttpRequest.prototype.send = function (...args) {\n    // Add a listener for when the request completes\n    this.addEventListener(\"load\", function () {\n      try {\n        // Check if the request is for the Judge.me reviews\n        if (typeof this._judgeme_url === \"string\" && this._judgeme_url.includes(\"api.judge.me/reviews/reviews_for_carousel_popups\")) {\n          // Try to parse JSON\n          if (request_count === 0) {\n            request_count++;\n            var responseText = this.responseText;\n            var data = JSON.parse(responseText); //console.log(\"🎯 Caught Judge.me Carousel Reviews (XHR):\", data);\n            // Save globally so your custom code can use it later\n\n            window.judgemeReviews = data;\n            var reviewEvent = new Event(\"judgeme-reviews-loaded\");\n            window.dispatchEvent(reviewEvent);\n          }\n        }\n      } catch (err) {\n        window.console.warn(\"Error intercepting Judge.me XHR:\", err);\n      }\n    });\n    return origSend.apply(this, args);\n  };\n})();\n\nclass JudgeMeCarousel extends window.HTMLElement {\n  connectedCallback() {\n    this.container = this;\n    this.judgemeSwiper = this.querySelector(\".swiper\");\n    this.attachListeners();\n  }\n\n  attachListeners() {\n    window.addEventListener(\"judgeme-reviews-loaded\", this.handleReviewsLoaded.bind(this));\n  }\n\n  handleReviewsLoaded() {\n    window.judgemeReviews.data.forEach(review => {\n      window.console.log(review);\n      var review_rating = review.rating;\n      var review_stars = \"\";\n\n      for (var i = 1; i <= 5; i++) {\n        if (review_rating >= i) {\n          // Full star\n          review_stars += \"<span class=\\\"custom-star full-star\\\"></span>\";\n        } else if (review_rating > i - 1) {\n          // Half star (when rating is between i-1 and i)\n          review_stars += \"<span class=\\\"custom-star half-star\\\"></span>\";\n        } else {\n          // Empty star\n          review_stars += \"<span class=\\\"custom-star empty-star\\\"></span>\";\n        }\n      }\n\n      var review_template = \"\\n        <a href=\\\"\".concat(review.product_url, \"\\\" class=\\\"judgeme-carousel-slide swiper-slide\\\">\\n          <div class=\\\"slide-header\\\">\\n            <div class=\\\"slide-product-image\\\"><img src=\\\"\").concat(review.medium_product_image_url, \"\\\" alt=\\\"\").concat(review.product_title, \"\\\" /></div>\\n            <div class=\\\"slide-product-info\\\">\\n              <div class=\\\"slide-product-title\\\">\").concat(review.product_title, \"</div>\\n              <span title=\\\"Ver Producto\\\" class=\\\"slide-product-link\\\">Ver Producto</span>\\n            </div>\\n          </div>\\n          <div class=\\\"slide-body\\\">\\n            <div class=\\\"slide-stars\\\">\").concat(review_stars, \"</div>\\n            <div class=\\\"slide-review-title\\\">\").concat(review.title, \"</div>\\n            <div class=\\\"slide-review-content\\\">\").concat(review.body_html, \"</div>\\n          </div>\\n          <div class=\\\"slide-footer\\\">\\n            <div class=\\\"slide-footer-author\\\">\").concat(review.public_reviewer_name, \"</div>\\n            <div class=\\\"slide-footer-date\\\">\").concat(review.user_friendly_created_at, \"</div>\\n          </div>\\n        </a>\\n      \");\n      this.judgemeSwiper.querySelector(\".swiper-wrapper\").insertAdjacentHTML(\"beforeend\", review_template);\n    });\n    new swiper__WEBPACK_IMPORTED_MODULE_0__.default(this.judgemeSwiper, {\n      slidesPerView: \"auto\",\n      spaceBetween: 8,\n      loop: false,\n      infinite: false,\n      navigation: {\n        nextEl: this.judgemeSwiper.querySelector(\".swiper-button-next\"),\n        prevEl: this.judgemeSwiper.querySelector(\".swiper-button-prev\"),\n        disabledClass: \"disabled_arrow\"\n      },\n      centerInsufficientSlides: true,\n      breakpoints: {\n        835: {\n          slidesPerView: \"auto\",\n          spaceBetween: 18\n        }\n      }\n    });\n  }\n\n}\n\nif (window.customElements.get(\"judgeme-carousel\") == null) {\n  window.customElements.define(\"judgeme-carousel\", JudgeMeCarousel);\n}\n\n//# sourceURL=webpack://getmore-workflow/./zrc/scripts/sections/judgeme-carousel-section.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"judgeme-carousel-section": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/sections/judgeme-carousel-section.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgetmore_workflow"] = self["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;